import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { subscribeToTicketEvents } from '../utils/ticketEventStream';
import { describeEvent, getState } from '../utils/desktopNotifications';
import { Globals } from '../globalfunctions.js';

// Raises a desktop alert for new tickets / customer replies when the user has
// turned alerts on and this tab is in the background. Renders nothing. It
// rides the shared ticket event stream the Sidebar already opens, so it adds
// no extra connection.
export default function TicketNotifier() {
  const navigate = useNavigate();

  useEffect(() => subscribeToTicketEvents((event) => {
    if (getState() !== 'on') return;
    const info = describeEvent(event, Globals.Id);
    if (!info) return;
    // New-ticket / reply alerts only fire when the tab is in the background;
    // reminders and mentions are for you personally, so they always do.
    if (!info.personal && !document.hidden) return;
    try {
      // tag: a second event for the same ticket replaces the first alert
      // instead of stacking.
      const alert = new Notification(info.title, { body: info.body, tag: info.ticketId });
      alert.onclick = () => {
        window.focus();
        navigate(`/tickets/${info.ticketId}`);
        alert.close();
      };
    } catch (err) {
      // Some browsers refuse the constructor outside a service worker; the
      // in-app indicators still work.
    }
  }), [navigate]);

  return null;
}
